var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ overlay: _vm.isOverlay },attrs:{"id":"app"}},[_c('header-wrapper'),_c('router-view'),_c('footer-wrapper'),_c('ClientOnly',[_c('at-cookies')],1),_c('CompareButton'),_c('BackToTop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }